import React from 'react';
import { Box } from '@mui/material';
import { colors, fonts, sizes, spacing, radius } from '../../styles/designTokens';

const FormInput = ({ name, value, placeholder, onChange, type = "text", ...props }) => {
    const input = (
        <Box
            component="input"
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            {...props}
            sx={{
                boxSizing: 'border-box',
                width: '100%',
                height: '48px',
                borderRadius: radius.lg, // 24px
                border: `2px solid ${colors.border}`,
                backgroundColor: props.readOnly ? '#F4F6F8' : colors.background_light,
                padding: `0 ${spacing.xl}`, // 20px
                fontFamily: fonts.poppins,
                fontSize: sizes.small || '14px',
                color: props.readOnly ? colors.text : colors.text_dark,
                outline: 'none',
                transition: 'border-color 0.2s',
                cursor: props.readOnly ? 'not-allowed' : 'text',
                caretColor: props.readOnly ? 'transparent' : 'auto',
                userSelect: props.readOnly ? 'none' : 'auto',
                pointerEvents: props.readOnly ? 'none' : 'auto',
                '&::placeholder': {
                    color: colors.text,
                    opacity: 0.7
                },
                '&:focus': {
                    borderColor: props.readOnly ? colors.border : colors.primary
                },
                ...props.sx
            }}
        />
    );

    if (props.readOnly) {
        return (
            <Box sx={{ cursor: 'not-allowed', width: '100%' }}>
                {input}
            </Box>
        );
    }

    return input;
};

export default FormInput;
